import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionReveal } from "../components/MotionReveal";

export default function CallToAction() {
  const appContext = useContext(AppContext);

  return (
    <section className="tgm-thin-cta">
      <div className="container">
        <MotionReveal className="tgm-thin-cta-shell" variant="card">
          <div>
            <span>Ready to plan your next project?</span>
            <strong>
              Talk to SNJ Tanzania Limited about civil works, building
              construction, or specialized project support.
            </strong>
          </div>
          <MotionReveal
            as="button"
            type="button"
            className="tgm-solid-btn"
            onClick={() => appContext.navTo({ item: "contact_us" })}
            variant="right"
            whileHover={{ x: 4 }}
            whileTap={{ scale: 0.96 }}
          >
            Contact us <MdArrowForward />
          </MotionReveal>
        </MotionReveal>
      </div>
    </section>
  );
}
